define('app/sdc/transclude/element/sdc-transclude-element',[], function () {
	return {
		restrict: "EA",
		transclude: "element",
		template: null,
		priority: 10000,
		controller: ["$transclude", "$element", "$attrs", function ($transclude, $element, $attrs) {
			this.$transclude = $transclude;
		}]
	}
});
